/* LEFTY'S — The Drop Test
 * Gravity-assessment email capture. A specimen drops through a peg array;
 * the prize is drawn from weighted slots first, then a path is animated to it,
 * so the discount mix is always what the merchant set in the theme editor.
 * No dependencies. Klaviyo client API + Shopify customer form fallback.
 */
(function () {
  'use strict';
  if (window.__leftyDropLoaded) return;
  window.__leftyDropLoaded = true;

  var ACID = '#E3FF47';
  var INK = '#0F1317';
  var PAPER = '#F2F1EC';
  var ROWS = 8;                 // peg rows; each row deflects the ball half a unit left or right
  // Board is 10 half-units wide = 5 slots. Ball starts at unit 5. After 8 rows the
  // net displacement s (rights minus lefts) must be a multiple of 4 to land on a
  // slot centre: s = -8 → slot 0 (far left) … s = 8 → slot 4 (far right).
  var S_FOR_SLOT = [[-8], [-4], [0], [4], [8]];

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
  function easeOutQuad(t) { return 1 - (1 - t) * (1 - t); }
  function easeInQuad(t) { return t * t; }
  function reducedMotion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* ---------- storage ---------- */
  function readStore(key) {
    try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }
  function writeStore(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* private mode: ignore */ }
  }
  function daysFromNow(d) { return Date.now() + d * 864e5; }

  /* ---------- weighted draw ---------- */
  function drawSlot(slots) {
    var total = 0, i;
    for (i = 0; i < slots.length; i++) total += Math.max(0, +slots[i].weight || 0);
    if (total <= 0) return 1; // default to LEFT if the merchant zeroed everything
    var r = Math.random() * total;
    for (i = 0; i < slots.length; i++) {
      r -= Math.max(0, +slots[i].weight || 0);
      if (r < 0) return i;
    }
    return slots.length - 1;
  }
  function pathForSlot(slot) {
    var choices = S_FOR_SLOT[slot];
    var s = choices[Math.floor(Math.random() * choices.length)];
    var rights = (ROWS + s) / 2, lefts = ROWS - rights, steps = [], i;
    for (i = 0; i < rights; i++) steps.push(1);
    for (i = 0; i < lefts; i++) steps.push(-1);
    for (i = steps.length - 1; i > 0; i--) { // shuffle so the fall looks natural
      var j = Math.floor(Math.random() * (i + 1)), t = steps[i]; steps[i] = steps[j]; steps[j] = t;
    }
    return steps;
  }

  /* ---------- the rig (canvas) ---------- */
  function Rig(canvas) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.ball = null;      // {x, y, r}
    this.landed = -1;
    this.raf = 0;
    this.idleT = 0;
    this.resize();
    var self = this;
    this._onResize = function () { self.resize(); self.draw(); };
    window.addEventListener('resize', this._onResize);
  }
  Rig.prototype.resize = function () {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = this.canvas.clientWidth || 340;
    var h = Math.round(w * (w < 420 ? 1.02 : 1.12));
    this.W = w; this.H = h;
    this.canvas.width = Math.round(w * dpr);
    this.canvas.height = Math.round(h * dpr);
    this.canvas.style.height = h + 'px';
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    // geometry
    this.pad = Math.round(w * 0.07);
    this.unit = (w - this.pad * 2) / 10;          // half-column unit; 5 slots = 10 units
    this.top = Math.round(h * 0.11);
    this.slotTop = Math.round(h * 0.84);
    this.rowGap = (this.slotTop - this.top - this.unit * 1.2) / ROWS;
    this.ballR = Math.max(6, this.unit * 0.42);
    this.cx = w / 2;
    if (!this.ball) this.ball = { x: this.cx, y: this.top - this.unit * 0.6, r: this.ballR };
  };
  Rig.prototype.pegXY = function (row, k) {
    // even rows: pegs on whole units (the first one sits dead under the ball);
    // odd rows: pegs on half units, so every bounce meets a peg
    var offset = (row % 2 === 0) ? 0 : 0.5;
    return { x: this.pad + (k + offset) * this.unit, y: this.top + this.unit * 0.6 + row * this.rowGap };
  };
  Rig.prototype.draw = function (flashSlot) {
    var c = this.ctx, W = this.W, H = this.H, i, k;
    c.clearRect(0, 0, W, H);
    // frame
    c.strokeStyle = 'rgba(15,19,23,0.55)';
    c.lineWidth = 1;
    c.strokeRect(0.5, 0.5, W - 1, H - 1);
    // header rule + drop gate
    c.beginPath(); c.moveTo(0, this.top - this.unit * 0.1); c.lineTo(W, this.top - this.unit * 0.1); c.setLineDash([3, 4]); c.stroke(); c.setLineDash([]);
    // gravity note (left-leaning arrow)
    c.fillStyle = 'rgba(15,19,23,0.55)';
    c.font = '600 9px "IBM Plex Mono", ui-monospace, monospace';
    c.textAlign = 'left';
    c.fillText('FIG. 09 — DROP RIG MK. I', 8, 14);
    c.textAlign = 'right';
    c.fillText('PEG ARRAY ' + ROWS + ' ROWS', W - 8, 14);
    c.textAlign = 'left';
    c.fillText('↙ LOCAL GRAVITY (ALLEGEDLY)', 8, H - 6);
    // pegs
    for (i = 0; i < ROWS; i++) {
      var kStart = (i % 2 === 0) ? 1 : 0, kEnd = (i % 2 === 0) ? 9 : 9;
      for (k = kStart; k <= kEnd; k++) {
        var p = this.pegXY(i, k);
        if (p.x < this.pad + 1 || p.x > W - this.pad - 1) continue;
        c.beginPath(); c.arc(p.x, p.y, Math.max(2, this.unit * 0.12), 0, Math.PI * 2);
        c.fillStyle = INK; c.fill();
      }
    }
    // slot dividers
    var y0 = this.slotTop, y1 = H - this.unit * 0.9;
    c.strokeStyle = 'rgba(15,19,23,0.8)';
    for (k = 0; k <= 5; k++) {
      var x = this.pad + k * this.unit * 2;
      c.beginPath(); c.moveTo(x, y0); c.lineTo(x, y1); c.stroke();
    }
    c.beginPath(); c.moveTo(this.pad, y1); c.lineTo(W - this.pad, y1); c.stroke();
    if (typeof flashSlot === 'number' && flashSlot >= 0) {
      c.fillStyle = ACID;
      c.fillRect(this.pad + flashSlot * this.unit * 2 + 1, y0 + 1, this.unit * 2 - 2, y1 - y0 - 1);
    }
    // ball
    if (this.ball) {
      c.beginPath(); c.arc(this.ball.x, this.ball.y, this.ball.r, 0, Math.PI * 2);
      c.fillStyle = ACID; c.fill();
      c.lineWidth = 2; c.strokeStyle = INK; c.stroke();
      // specimen mark
      c.beginPath(); c.moveTo(this.ball.x - this.ball.r * 0.45, this.ball.y); c.lineTo(this.ball.x + this.ball.r * 0.45, this.ball.y); c.stroke();
    }
  };
  Rig.prototype.idle = function () {
    var self = this;
    if (reducedMotion()) { this.draw(); return; }
    cancelAnimationFrame(this.raf);
    var t0 = now();
    function loop() {
      var t = (now() - t0) / 1000;
      self.ball.y = self.top - self.unit * 0.6 + Math.sin(t * 2.2) * 2.5;
      self.draw();
      self.raf = requestAnimationFrame(loop);
    }
    loop();
  };
  Rig.prototype.stop = function () { cancelAnimationFrame(this.raf); };
  Rig.prototype.slotCenterX = function (slot) { return this.pad + slot * this.unit * 2 + this.unit; };
  Rig.prototype.drop = function (steps, slot, onDone) {
    var self = this;
    this.stop();
    if (reducedMotion()) {
      this.ball.x = this.slotCenterX(slot);
      this.ball.y = this.H - this.unit * 0.9 - this.ball.r - 2;
      this.draw(slot);
      setTimeout(function () { onDone && onDone(); }, 250);
      return;
    }
    var segs = [], x = this.cx, y = this.top - this.unit * 0.6, i;
    // fall to the first peg row
    segs.push({ x0: x, y0: y, x1: x, y1: this.top + this.unit * 0.6 - this.ballR, dur: 260, kind: 'fall' });
    y = this.top + this.unit * 0.6 - this.ballR;
    for (i = 0; i < steps.length; i++) {
      var nx = x + steps[i] * this.unit * 0.5;
      var ny = y + this.rowGap;
      segs.push({ x0: x, y0: y, x1: nx, y1: ny, dur: 230 + Math.random() * 60, kind: 'peg' });
      x = nx; y = ny;
    }
    var endX = this.slotCenterX(slot);
    var endY = this.H - this.unit * 0.9 - this.ballR - 2;
    segs.push({ x0: x, y0: y, x1: endX, y1: endY, dur: 320, kind: 'land' });
    var si = 0, t0 = now();
    function frame() {
      var s = segs[si], t = Math.min(1, (now() - t0) / s.dur);
      if (s.kind === 'peg') {
        // sideways glance off the peg: quick horizontal, gravity-shaped vertical
        self.ball.x = s.x0 + (s.x1 - s.x0) * easeOutQuad(Math.min(1, t * 1.35));
        self.ball.y = s.y0 + (s.y1 - s.y0) * easeInQuad(t);
      } else if (s.kind === 'land') {
        self.ball.x = s.x0 + (s.x1 - s.x0) * easeOutQuad(t);
        var bounce = Math.sin(Math.min(1, t) * Math.PI) * self.unit * 0.25 * (1 - t);
        self.ball.y = s.y0 + (s.y1 - s.y0) * easeInQuad(t) - bounce;
      } else {
        self.ball.x = s.x1;
        self.ball.y = s.y0 + (s.y1 - s.y0) * easeInQuad(t);
      }
      self.draw(t >= 1 && si === segs.length - 1 ? slot : undefined);
      if (t >= 1) {
        si++; t0 = now();
        if (si >= segs.length) {
          self.landed = slot;
          // settle flash
          var flashes = 0;
          var fl = setInterval(function () {
            flashes++; self.draw(flashes % 2 ? slot : undefined);
            if (flashes >= 6) { clearInterval(fl); self.draw(slot); onDone && onDone(); }
          }, 110);
          return;
        }
      }
      self.raf = requestAnimationFrame(frame);
    }
    frame();
  };

  /* ---------- subscribe ---------- */
  function subscribeKlaviyo(cfg, email, props) {
    if (!cfg.klaviyoCompanyId || !cfg.klaviyoListId) return Promise.resolve(false);
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source || "Lefty's Drop Test",
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.klaviyoListId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.klaviyoCompanyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.status >= 200 && r.status < 300; }).catch(function () { return false; });
  }
  function subscribeShopify(cfg, email, tags) {
    if (!cfg.shopifyCustomer) return Promise.resolve(false);
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', tags.join(','));
    return fetch(cfg.accountUrl || '/account', { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'follow' })
      .then(function () { return true; }).catch(function () { return false; });
  }

  /* ---------- controller ---------- */
  function DropTest(root) {
    var cfg;
    try { cfg = JSON.parse(root.getAttribute('data-config') || '{}'); } catch (e) { cfg = {}; }
    this.root = root; this.cfg = cfg;
    cfg.slots = (cfg.slots || []).slice(0, 5);
    while (cfg.slots.length < 5) cfg.slots.push(cfg.slots[cfg.slots.length - 1] || { side: '', label: '', code: '', weight: 1 });
    this.key = 'lefty_drop_' + (cfg.storageKey || 'v1');
    this.popup = cfg.mode === 'popup';
    this.overlay = $(root, '[data-drop-overlay]');
    this.tab = $(root, '[data-drop-open]');
    this.form = $(root, '[data-drop-form]');
    this.email = $(root, '[data-drop-email]');
    this.error = $(root, '[data-drop-error]');
    this.status = $(root, '[data-drop-status]');
    this.intro = $(root, '[data-drop-intro]');
    this.result = $(root, '[data-drop-result]');
    this.canvas = $(root, '[data-drop-canvas]');
    this.slotEls = $$(root, '[data-drop-slot]');
    this.rig = null;
    this.busy = false;
    this.opened = false;
    this.bind();
    if (this.popup) this.arm(); else this.mount();
  }
  DropTest.prototype.mount = function () {
    if (!this.rig && this.canvas) { this.rig = new Rig(this.canvas); this.rig.idle(); }
    var state = readStore(this.key);
    if (state && state.done && state.code && this.cfg.rememberResult) this.showResult(state, true);
  };
  DropTest.prototype.bind = function () {
    var self = this;
    if (this.form) {
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
    }
    $$(this.root, '[data-drop-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(true); }); });
    if (this.overlay) {
      this.overlay.addEventListener('click', function (e) { if (e.target === self.overlay) self.close(true); });
    }
    if (this.tab) this.tab.addEventListener('click', function () { self.open(); });
    var copy = $(this.root, '[data-drop-copy]');
    if (copy) copy.addEventListener('click', function () {
      var code = $(self.root, '[data-drop-code]').textContent.trim();
      var done = function () { copy.textContent = self.cfg.t.copied || 'COPIED'; setTimeout(function () { copy.textContent = self.cfg.t.copy || 'COPY'; }, 1600); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done); else done();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.opened) self.close(true); });
    // anyone on the page can open the rig: <a href="#drop-test"> or [data-lefty-drop-open]
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-lefty-drop-open], a[href$="#drop-test"]') : null;
      if (!t) return;
      if (self.popup) { e.preventDefault(); self.open(true); }
    });
    document.addEventListener('lefty:drop:open', function () { if (self.popup) self.open(true); });
    // theme editor: show when the merchant selects the section
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) { if (self.root.closest('.shopify-section') === e.target) self.open(true); });
      document.addEventListener('shopify:section:deselect', function (e) { if (self.root.closest('.shopify-section') === e.target) self.close(false); });
    }
  };
  DropTest.prototype.suppressed = function () {
    var s = readStore(this.key);
    if (!s) return false;
    if (s.done && s.doneUntil && Date.now() < s.doneUntil) return true;
    if (s.dismissedUntil && Date.now() < s.dismissedUntil) return true;
    return false;
  };
  DropTest.prototype.arm = function () {
    var self = this, cfg = this.cfg;
    if (window.Shopify && Shopify.designMode) return;               // editor: only on select
    if (/[?&]nodrop\b/.test(location.search)) return;
    if (cfg.excludeTemplates && cfg.excludeTemplates.indexOf(cfg.template) !== -1) return;
    if (cfg.suffix === 'drop-test') return;      // the walk-in page has the inline rig
    if (cfg.showOn === 'home' && cfg.template !== 'index') return;
    if (this.suppressed()) { if (this.tab && cfg.showTab && !(readStore(this.key) || {}).done) this.tab.hidden = false; return; }
    if (this.tab && cfg.showTab) this.tab.hidden = false;
    var trig = cfg.trigger || 'delay_or_exit';
    var fired = false;
    function fire() { if (fired) return; fired = true; self.open(false); }
    if (trig === 'delay' || trig === 'delay_or_exit') {
      // "time on site": the delay counts total seconds this session, across pages,
      // not time on the current page. Progress is kept in sessionStorage.
      var tKey = this.key + '_t';
      var spent = 0;
      try { spent = +sessionStorage.getItem(tKey) || 0; } catch (e) {}
      var armT0 = Date.now();
      var saveSpent = function () { try { sessionStorage.setItem(tKey, String(spent + (Date.now() - armT0))); } catch (e) {} };
      window.addEventListener('pagehide', saveSpent);
      setInterval(saveSpent, 5000);
      var delayMs = Math.max(0, (+cfg.delaySeconds || 0) * 1000);
      setTimeout(fire, Math.max(spent >= delayMs ? 1200 : 0, delayMs - spent));
    }
    if (trig === 'exit' || trig === 'delay_or_exit') {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) fire(); });
      // mobile has no exit intent: fall back to scroll depth
      if (matchMedia('(hover: none)').matches && trig === 'exit') {
        window.addEventListener('scroll', function onS() { if (scrollDepth() >= 55) { fire(); window.removeEventListener('scroll', onS); } }, { passive: true });
      }
    }
    if (trig === 'scroll') {
      var pct = +cfg.scrollPercent || 40;
      window.addEventListener('scroll', function onS() { if (scrollDepth() >= pct) { fire(); window.removeEventListener('scroll', onS); } }, { passive: true });
    }
    function scrollDepth() {
      var h = document.documentElement, max = (h.scrollHeight - h.clientHeight) || 1;
      return (window.scrollY / max) * 100;
    }
  };
  DropTest.prototype.open = function (manual) {
    if (!this.popup) return;
    if (this.opened) return;
    this.opened = true;
    this.overlay.hidden = false;
    document.documentElement.classList.add('lefty-drop-open');
    if (this.tab) this.tab.hidden = true;
    var self = this;
    requestAnimationFrame(function () {
      self.overlay.classList.add('is-open');
      self.mount();
      if (self.email && !manual) setTimeout(function () { try { self.email.focus({ preventScroll: true }); } catch (e) {} }, 350);
      else if (self.email) setTimeout(function () { try { self.email.focus({ preventScroll: true }); } catch (e) {} }, 350);
    });
    this.track('lefty_drop_open');
  };
  DropTest.prototype.close = function (remember) {
    if (!this.popup || !this.opened) return;
    this.opened = false;
    this.overlay.classList.remove('is-open');
    document.documentElement.classList.remove('lefty-drop-open');
    var self = this;
    setTimeout(function () { self.overlay.hidden = true; if (self.rig) self.rig.stop(); }, 260);
    if (remember) {
      var s = readStore(this.key) || {};
      if (!s.done) { s.dismissedUntil = daysFromNow(+this.cfg.dismissDays || 7); writeStore(this.key, s); }
      if (this.tab && this.cfg.showTab && !s.done) this.tab.hidden = false;
    }
  };
  DropTest.prototype.setStatus = function (txt) { if (this.status) this.status.textContent = txt; };
  DropTest.prototype.fail = function (msg) { if (this.error) { this.error.textContent = msg; this.error.hidden = false; } };
  DropTest.prototype.submit = function () {
    var self = this, cfg = this.cfg, t = cfg.t || {};
    if (this.busy) return;
    var email = (this.email.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { this.fail(t.invalid || 'That email did not take. Check it and try again.'); return; }
    if (this.error) this.error.hidden = true;
    this.busy = true;
    var btn = $(this.form, 'button[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = t.releasing || 'RELEASING…'; }
    this.setStatus(t.statusDropping || 'SPECIMEN: IN FLIGHT');
    var slotIndex = drawSlot(cfg.slots);
    var slot = cfg.slots[slotIndex];
    var side = slotIndex < 2 ? 'left' : slotIndex === 2 ? 'center' : 'right';
    var props = { drop_test_result: side, drop_test_slot: slot.side, drop_test_prize: slot.label, drop_test_code: slot.code, drop_test_source: cfg.source || "Lefty's Drop Test" };
    // fire the subscriptions; never block the animation on the network
    subscribeKlaviyo(cfg, email, props).then(function (ok) { if (!ok && cfg.klaviyoCompanyId) console.warn('[Lefty\'s Drop Test] Klaviyo subscribe did not confirm — check company ID and list ID.'); });
    subscribeShopify(cfg, email, ['drop-test', 'drop-' + side, slot.code ? 'code-' + slot.code : 'no-code']);
    this.track('lefty_drop_submit', { result: side, prize: slot.label });
    var state = { done: true, doneUntil: daysFromNow(+cfg.doneDays || 180), side: side, slot: slotIndex, label: slot.label, code: slot.code, email: email, at: Date.now() };
    writeStore(this.key, state);
    if (!this.rig) this.mount();
    try { this.canvas.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'nearest' }); } catch (e) {}
    var steps = pathForSlot(slotIndex);
    this.rig.drop(steps, slotIndex, function () {
      self.busy = false;
      self.showResult(state, false);
      try { var r = $(self.root, '[data-drop-result]'); if (r && window.innerWidth < 760) r.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' }); } catch (e) {}
    });
  };
  DropTest.prototype.showResult = function (state, restored) {
    var cfg = this.cfg, t = cfg.t || {}, side = state.side;
    this.slotEls.forEach(function (el, i) { el.classList.toggle('is-hit', i === state.slot); });
    if (this.intro) this.intro.hidden = true;
    if (this.result) this.result.hidden = false;
    this.setStatus(t.statusLanded || 'SPECIMEN: LANDED');
    var title = side === 'left' ? t.leftTitle : side === 'center' ? t.centerTitle : t.rightTitle;
    var sub = side === 'left' ? t.leftSub : side === 'center' ? t.centerSub : t.rightSub;
    var set = function (sel, txt) { var el = $(this.root, sel); if (el) el.textContent = txt || ''; }.bind(this);
    set('[data-drop-result-title]', title);
    set('[data-drop-result-sub]', sub);
    set('[data-drop-prize]', state.label);
    set('[data-drop-code]', state.code || '');
    var codeWrap = $(this.root, '[data-drop-code-wrap]');
    if (codeWrap) codeWrap.hidden = !state.code;
    var shop = $(this.root, '[data-drop-shop]');
    if (shop) {
      var label = (t.shopLabel || 'SHOP WITH [PRIZE]').replace('[PRIZE]', state.label);
      shop.textContent = label;
      var target = cfg.shopUrl || '/';
      shop.href = state.code ? ('/discount/' + encodeURIComponent(state.code) + '?redirect=' + encodeURIComponent(target)) : target;
    }
    if (restored) { if (this.rig) { this.rig.stop(); this.rig.ball.x = this.rig.slotCenterX(state.slot); this.rig.ball.y = this.rig.H - this.rig.unit * 0.9 - this.rig.ballR - 2; this.rig.draw(state.slot); } }
    this.track('lefty_drop_result', { result: side, prize: state.label });
  };
  DropTest.prototype.track = function (name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, data || {}));
    } catch (e) { /* no analytics: fine */ }
  };

  function init() {
    $$(document, '[data-lefty-drop]').forEach(function (root) {
      if (root.__drop) return;
      root.__drop = new DropTest(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
